import { render } from "./sub-menu-delivery.vue?vue&type=template&id=0270066c"
import script from "./sub-menu-delivery.vue?vue&type=script&lang=js"
export * from "./sub-menu-delivery.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__